import api_alarm from "@/api/apiAlarm";
import api_exchange from "@/api/apiExchange";

export default {
  namespaced: true,
  state() {
    return {
      // 이전에 선택한 알람 활성화 상태 및 알람음 조회
      goyaAlram: [],

      // 알람음 변경
      selectSound: 1, // 알람음 id
      clickSound: "기본음", // 기본음 or Sound N
      rsiChk: false, // 알람 활성화 상태

      // 코인 등록 및 등록 코인 조회
      goyaCoin: [],

      // 거래소별 코인 리스트
      binanceList: [],
      bybitList: [],
      okxList: [],

      // 사용가능한 거래소
      availExc: [],

      // RSI 등록할 코인 리스트
      putCoin: [],

      // goya-alarm-coins isSuccess 확인
      checkCoin: false,

      // Histories
      rsiHist: [],
    };
  },
  mutations: {
    // 알람음 변경시 id 반영
    chooseSound(state, value) {
      state.selectSound = value;
    },
    // 알람음 변경시 기본음/Sound N 반영
    changeSound(state, value) {
      state.clickSound = value;
    },
    // 알람 활성화 상태 변경
    changeActive(state, payload) {
      state.rsiChk = payload.state;
    },

    // RSI 히스토리 등록할 코인 리스트
    saveRsiCoins(state, data) {
      state.putCoin = data;
    },
  },
  actions: {
    // 각 거래소별 코인 리스트 조회
    async getBinanceList(context) {
      try {
        const result = await api_exchange.getBinanceList();
        context.state.binanceList = result.tickers;
      } catch (error) {
        // // console.log("getBinanceList: ", error);
        return;
      }
    },
    async getBybitList(context) {
      try {
        const result = await api_exchange.getBybitList();
        context.state.bybitList = result.tickers;
      } catch (error) {
        // // console.log("getBybitList: ", error);
        return;
      }
    },
    async getOkxList(context) {
      try {
        const result = await api_exchange.getOkxList();
        context.state.okxList = result.tickers;
      } catch (error) {
        // // console.log("getOkxList: ", error);
        return;
      }
    },
  

    // insight 등록 코인 조회
    async getCoinList(context) {
      try {
        const result = await api_alarm.getSeletedCoins();
        if (result.isSuccess) {
          context.state.goyaCoin = result.data;
          // context.state.checkCoin = true;
        }
      } catch (error) {
        // // console.log("getCoinList: ", error);
        return;
      }
    },

    // insight 코인 등록하는 함수
    async putCoinList(context) {
      try {
        const data = context.state.putCoin;
        // console.log('data', data)
        await api_alarm.setSeletedCoins(data);
      } catch (error) {
        // // console.log("putcoinlist: ", error);
        return;
      }
    },
  },
};
